// extracted by extract-css-chunks-webpack-plugin
module.exports = {"viewMore":"viewMore-C9Vfptl4","viewMoreLink":"viewMoreLink-2xthd81Y"};